// extracted by mini-css-extract-plugin
export default {"subtitle":"auth_subtitle__cSrFU","title":"auth_title__+e1TX","form":"auth_form__mGor+"};